import { IonLabel, isPlatform } from "@ionic/react";
import React from "react";
import { SocialIcons } from "../../CustomComponents/SocialIcons";
import OtpScreen from "../../Login/otp";
import * as constants from "../../../constants";
import {
  // AnonymousToFacebookAccount,
  AnonymousToGoogleAccount,
  formatError,
  signInWithApple,
  // signInWithFaceBook,
  signInWithGoogle,
} from "../../../firebase";
import { ToastMessage } from "../../../utils/toastMessage";

export const OtpInCart: React.FC = (props: any) => {
  const [toast, setToast] = React.useState({
    showToast: false,
    toastMessage: "",
    severity: "",
  });
  async function formatError(result: any) {
    if (!result.hasOwnProperty("token")) {
      const splitted = result.message;
      if (splitted) {
        setToast({
          showToast: true,
          toastMessage: splitted,
          severity: "danger",
        } as any);
        return;
      }
    } else {
      setToast({
        showToast: true,
        toastMessage: "Account created successfully",
        severity: "success",
      } as any);
      setTimeout(async () => {
        await props.updateOnBoarding({ isAnonymous: false });
        await props.modifyToken({
          token: result.token,
          email: result.email || "",
          profileImagePath: result.photoURL || "",
          name: result.displayName || "",
          providerId: result.providerId || "",
        });
        props.setLogin();
      }, 1000);
    }
  }
  return (
    <div
      style={{
        marginRight: 20,
        marginLeft: 20,
      }}
    >
      <OtpScreen {...props} uiChange={true} />
      <div className="anonymous_social_div">
        <div
          className="login26"
          style={{
            visibility: isPlatform("ios") ? "hidden" : "visible",
          }}
        >
          <div className="login28" />
          <IonLabel className="orLoginWith" color="tertiary">
            {constants.OR_LOGIN_WITH}
          </IonLabel>
          <div className="login28" />
        </div>
        {!isPlatform("ios") && (
          <div className="login29" style={{ width: "auto" }}>
            <SocialIcons
              {...props}
              changeStyle={true}
              imgpath="/images/google.svg"
              label={constants.GOOGLE}
              onClick={async () => {
                const result = await AnonymousToGoogleAccount();
                formatError(result);
              }}
            />
            {/* <SocialIcons
              {...props}
              changeStyle={true}
              imgpath="/images/facebook.svg"
              label={constants.FACEBOOK}
              onClick={async () => {
                const result = await AnonymousToFacebookAccount();
                formatError(result);
              }}
            /> */}
            {isPlatform("ios") && (
              <SocialIcons
                {...props}
                changeStyle={true}
                imgpath="/images/apple.svg"
                label={constants.APPLE}
                onClick={async () => {
                  const result = await signInWithApple();
                  formatError(result);
                }}
              />
            )}
          </div>
        )}
        <ToastMessage
          showToast={toast.showToast}
          ToastMessage={toast.toastMessage}
          severity={toast.severity}
          onDidDismiss={() => {
            setToast({
              showToast: false,
              toastMessage: "",
              severity: "",
            });
          }}
        />
      </div>
    </div>
  );
};
export default OtpInCart;
